<div class="group">
  <label>{{ 'state_or_province.label' | translate }}</label>
  <input
    data-testid="state-or-province"
    [formControl]="stateOrProvinceControl"
    type="text"
    [placeholder]="'state_or_province.placeholder' | translate"
    class="quantum-input"
    [ngClass]="stateOrProvinceControl.invalid ? 'invalid' : ''"
  />
  <div
    *ngIf="
      stateOrProvinceControl.invalid &&
      stateOrProvinceControl.errors &&
      stateOrProvinceControl.dirty
    "
    [class.dirty]="stateOrProvinceControl.dirty"
    class="error-message"
  >
    <div *ngIf="stateOrProvinceControl.errors['required']">
      {{ 'state_or_province.required' | translate }}
    </div>
  </div>
</div>
